import { render } from "./TableColumnForm.vue?vue&type=template&id=c9b29b5e&scoped=true&ts=true"
import script from "./TableColumnForm.vue?vue&type=script&lang=ts"
export * from "./TableColumnForm.vue?vue&type=script&lang=ts"

import "./TableColumnForm.vue?vue&type=style&index=0&id=c9b29b5e&scoped=true&lang=css"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9b29b5e"]])

export default __exports__